// Externals
//import deburr from 'lodash/deburr';

// DevExtreme helpers
import CustomStore from 'devextreme/data/custom_store';

export const useBosAutoCompletion = (autocompleteId, getAutocompleteSuggestions) => {
  const maxResults = 10;
  let suggestionsCache = null;
  
  function getSuggestions(prefix, searchType) {
    if (!autocompleteId) return null;
    const inputValue = prefix.trim();
    const inputLength = inputValue.length;

    if (suggestionsCache) {
      return filterSuggestions(suggestionsCache, searchType, inputValue, inputLength);
    }
    else {
      return getAutocompleteSuggestions(autocompleteId, inputValue, maxResults)
        .then(result => handleCache(result))
        .then(result => filterSuggestions(result.suggestions, searchType, inputValue, inputLength));
    }
  }

  function handleCache(result) {
    if (result.isCompleteList) {
      suggestionsCache = result.suggestions;
    }
    else {
      suggestionsCache = null;
    }
    return result;
  }

  function filterSuggestions(suggestions, searchType, inputValue, inputLength) {
    switch (searchType) {
      case "startswith": {
        return suggestions.filter(suggestion => {
          return suggestion.displayData.slice(0, inputLength).toLowerCase() === inputValue.toLowerCase();
        });
      }
      case "contains":
      default: {
        return suggestions.filter(suggestion => {
          return suggestion.displayData.toLowerCase().includes(inputValue.toLowerCase());
        });
      }
    }
  }

  const store = new CustomStore({
    byKey: () => {},
    load: (loadOptions) => {
      if (!loadOptions || !loadOptions.searchValue) return null;
      //console.log("AutoCompletion LoadOptions", loadOptions);
      return getSuggestions(loadOptions.searchValue, loadOptions.searchOperation);
    }
  });

  return {
    store
  };
};